// extracted by mini-css-extract-plugin
export default {"container":"Accounting_container__P82Tb"};